import styled from '@emotion/styled';
import { FormControl, FormHelperText, Input } from '@material-ui/core';
import Error from '@material-ui/icons/Error';
import { ChangeEvent, createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { ValidationError } from '../../../../../entity/ValidationResult';
import { DynamicSchemaDefinitionPositiveInteger } from '../../../../../generated/graphql';
import { SPACING_UNIT } from '../../../../constant/spacing';
import { PositiveIntegerValue } from '../../../../types/DynamicSchema';
import LfToBr from '../../../primitive/LfToBr';
import Base from './Base';

type Props = {
  field: DynamicSchemaDefinitionPositiveInteger;
  value: PositiveIntegerValue;
  errors: Array<ValidationError>;
  onChange: (e: ChangeEvent<HTMLElement>, value: PositiveIntegerValue) => void;
  className?: string;
};

const PositiveIntegerField: FC<Props> = ({ field, value, errors, onChange, className }) => {
  const validationErrorTexts = errors.map((err) => (
    <FormHelperText error key={err.message}>
      <StyledErrorIcon />

      <FormattedMessage id={`creative_brief_editor.field.validation_error.${err.message}`} />
    </FormHelperText>
  ));

  return (
    <Base field={field} labelPaddingTop={6} className={className}>
      <FormControl fullWidth required={field.isRequired}>
        <Input
          id={`positive-integer-field-${field.key}`}
          type="number"
          defaultValue={value}
          error={errors.length >= 1}
          onChange={(e) => onChange(e, e.currentTarget.value === '' ? null : parseInt(e.currentTarget.value, 10))}
        />

        {validationErrorTexts}

        <FormHelperText>
          <LfToBr text={field.helperText} />
        </FormHelperText>
      </FormControl>
    </Base>
  );
};

const StyledErrorIcon = styled(Error)`
  width: 14px;
  height: 14px;
  margin-right: ${SPACING_UNIT / 2}px;
  vertical-align: bottom;
`;

export default PositiveIntegerField;
